import { gql } from 'graphql-request';
import { Order } from 'modules/order/types';
import { GetToken } from 'modules/order/utils/useGetUser';
import { getGraphqlClient } from 'shared/graphql/useGraphQlClient';

export interface Payload {
    note: string;
    description: string;
    supplierPartNumber: string | null;
    manufacturerPartNumber: string | null;
    userPrice: {
        value: number;
        vatIncluded: boolean;
        vatRate: number;
    };
    quantity: {
        value: number;
        unit: string;
    };
    deliveryDate?: {
        start: string;
        end: string;
    };
}

export interface CreateOrderItemsParam {
    getToken: GetToken;
    orderId: string;
    input: Payload;
}

export interface ICreateOrderResponse {
    addOrderItem: Order;
}

const createOrderItems = () => async (param: CreateOrderItemsParam) => {
    const { getToken, ...payload } = param;
    const { graphQLClient } = await getGraphqlClient(getToken);
    const addOrderItem = gql`
        mutation addOrderItem($orderId: String!, $input: OrderItemCreate) {
            addOrderItem(orderId: $orderId, input: $input) {
                ... on Order {
                    id
                    status
                    items {
                        ... on OrderItem {
                            id
                            description
                            quantity {
                                value
                                unit
                            }
                            userPrice {
                                value
                                vatIncluded
                                vatRate
                            }
                            creator {
                                id
                                name
                            }
                            unitPriceCentsNet
                            totalPriceCentsNet
                            totalPriceCentsGross
                            totalVatAmountCents
                            supplierPartNumber
                            manufacturerPartNumber
                            note
                            createdDate
                            updatedDate
                            deliveryDate {
                                start
                                end
                            }
                        }
                    }
                    updatedDate
                    totalPriceCentsNet
                    totalPriceCentsGross
                    totalVatAmountBreakdown {
                        vatRate
                        amountCents
                    }
                }
            }
        }
    `;

    const data = await graphQLClient.request<ICreateOrderResponse>(addOrderItem, {
        ...payload,
    });

    return data;
};

export default createOrderItems;
